/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Edit = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.9481 16.2652C11.7355 16.4778 11.4638 16.6216 11.1685 16.6779L8.54715 17.1779C7.50698 17.3763 6.59426 16.4636 6.79267 15.4234L7.29267 12.8021C7.34901 12.5068 7.49282 12.2351 7.70544 12.0225L15.8644 3.86354C17.036 2.69197 18.9355 2.69197 20.1071 3.86354C21.2786 5.03512 21.2786 6.93461 20.1071 8.10618L11.9481 16.2652ZM8.2661 15.7045L8.7661 13.0832L16.9251 4.9242C17.5109 4.33842 18.4606 4.33842 19.0464 4.9242C19.6322 5.50999 19.6322 6.45974 19.0464 7.04552L10.8874 15.2045L8.2661 15.7045Z"
                        fill={color}
                    />
                    <path
                        d="M4.5 3.00005C3.67157 3.00005 3 3.67163 3 4.50005V19.5001C3 20.3285 3.67157 21.0001 4.5 21.0001H19.5C20.3284 21.0001 21 20.3285 21 19.5001V11.0001H19.5V19.5001H4.5V4.50005H12V3.00005H4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
